<template>
  <b-popover
    :id="'popoverEtiqueta'"
    ref="popoverEtiqueta"
    :target="'etiqueta'"
    :triggers="['click']"
    placement="auto"
    :show.sync="popoverShow"
    custom-class="multiselect-popover-filtro"
    @show="onShow"
  >
    <template #title>
      <div class="cadastro-etiqueta-header">
        <b-button
          v-if="mode !=='visualizacao'"
          variant="none"
          class="back"
          @click.prevent.stop="voltar()"
        >
          <font-awesome-icon :icon="faChevronLeft" />
        </b-button>
        <span>{{ currentHeader }}</span>

        <b-button
          variant="none"
          class="close"
          @click="onClose"
        >
          <span aria-hidden="true">&times;</span>
        </b-button>
      </div>
    </template>

    <div
      @keyup.esc.stop="onClose"
    >
      <div
        v-if="mode === 'visualizacao'"
        :class="{'search-results': (etiquetas.length === 0 && valorAProcurar) || etiquetas.length === 1}"
      >
        <div style="margin-bottom: 0.5rem;">
          <div class="procurar-etiqueta">
            <b-input
              v-model="valorAProcurar"
              name="inputSearch"
              placeholder="Procurar"
              autofocus
              class="search-item"
            />
            <label
              name="labelSearch"
              for="inputSearch"
              class="fas fa-search search icon"
              style="margin-left: 0.5rem;"
            />
          </div>
          <b-btn
            variant="none"
            class="btn btn-sm"
            style="display: contents;"
            @click.prevent.stop="mudarModo('adicao')"
          >
            <i class="fas fa-plus" />
          </b-btn>
        </div>
      </div>

      <div v-if="mode === 'visualizacao'">
        <div
          v-for="etiqueta in etiquetas"
          :key="etiqueta.id"
          style="display: inline-flex;align-items: center;"
        >
          <div
            :class="['etiqueta', {'desabilitar-inputs': etiqueta.etiquetaSistema }]"
            :style="'background-color:' + etiqueta.cor"
            @click.stop="selecionado(etiqueta)"
          >
            <span style="font-size: 12.5px;">{{ etiqueta.descricao }}</span>
            <span v-if="etiqueta.selecionada"><i class="fas fa-check" /></span>
          </div>

          <b-btn
            v-if="!etiqueta.etiquetaSistema"
            variant="none"
            class="btn btn-sm etiqueta-selecionada-edit"
            @click="mudarModo('edicao', etiqueta)"
          >
            <i class="fas fa-edit" />
          </b-btn>
        </div>
      </div>

      <div v-if="mode === 'adicao' || mode === 'edicao'">
        <div class="nome-etiqueta">
          <label>Nome da etiqueta</label>
          <b-input
            v-model="etiquetaAtual.descricao"
            autofocus
          />
        </div>

        <div class="cor-etiqueta">
          <label>Cor da etiqueta</label>
          <div
            v-for="cor in cores"
            :key="cor"
            :style="`background-color:${cor}`"
            :class="{'etiqueta-selecionada': etiquetaAtual.cor == cor}"
            @click.prevent.stop="mudarCor(cor)"
          />

        </div>

        <div
          v-if="mode === 'edicao'"
          class="btn-etiqueta"
        >
          <b-btn
            variant="outline-primary"
            class="btn-sm w-50 mr-50"
            @click.stop="update()"
          >
            Salvar
          </b-btn>
          <b-btn
            variant="outline-danger"
            class="btn-sm w-50"
            @click.stop="mudarModo('remover', etiquetaAtual)"
          >
            Deletar
          </b-btn>
        </div>

        <div
          v-if="mode === 'adicao'"
          style="btn-etiqueta"
          @click.stop="save()"
        >
          <b-btn
            variant="outline-primary"
            class="btn-sm w-100"
          >
            Criar
          </b-btn>
        </div>
      </div>
      <div
        v-if="mode === 'remover'"
      >
        <p style="font-size: 15px;">
          Ao salvar a proposta, essa ação irá remover a etiqueta desta e das demais propostas.</p>
        <p style="font-size: 15px;">
          Deseja realmente deletar?</p>
        <b-btn
          variant="outline-danger"
          class="w-100"
          @click="remove()"
        >Deletar</b-btn>
      </div>
    </div>
  </b-popover>
</template>

<style lang="scss">

.multiselect-popover-filtro {
  max-width: 282px;
}

.multiselect-popover-filtro .arrow {
  visibility: hidden;
}

.multiselect-popover-filtro .popover-body {
  //max-height: //610px;//310px;
  max-height: 585px;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar {
      width: 10px;
      background-color: #f5f5f5;
      }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #bfbfbf;
    }
}

.cadastro-etiqueta-header {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .close {
    right: 0;
  }

  .back {
    color: inherit;
    text-shadow: none;
    background-color: transparent;
    -webkit-appearance: none;
    font-size: 1.341rem;
    font-weight: 300;
    line-height: 1;
    opacity: 0.5;
    padding: 0;
    border: 0;
  }
}

.etiqueta {
  max-width: 210px;
  border-radius: 4px;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  &:hover {
    opacity: 4px;
  }

  & span {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    margin-right: 0.3rem;
  }

  & span:first-child {
    width: 210px;
    margin: 0.2rem;
    margin-left: 0.3rem;
  }
}

.etiqueta-selecionada-edit {
  float: right !important;
}

.nome-etiqueta {
  display: block;
  margin-bottom: 0.4rem;
  margin-top: 0.4rem;

  & > label {
    font-size: 0.9rem;
    display: block;
  }
}

.cor-etiqueta {
  display: block;
  margin-bottom: 0.4rem;
  margin-top: 0.4rem;

  & > label {
    font-size: 0.9rem;
    display: block;
  }

  & > div {
    height: 40px;
    width: 45px;
    margin: 0.2rem;
    border-radius: 4px;
    display: inline-flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
  }

  .etiqueta-selecionada {
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.507), 0 6px 20px 0 rgba(0, 0, 0, 0.301);
  }
}

.btn-etiqueta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.4rem;
  margin-top: 0.4rem;

  & > button {
    height: 35px !important;
    min-height: 35px !important;
  }
}

.search-item:focus {
  border-color: var(--primary)
}

.procurar-etiqueta {
  display: inline-flex;
  align-items: center;
  margin-right: 0.5rem;
}

.desabilitar-inputs {
  pointer-events: none;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapActions } from 'vuex'

import {
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/components/cadastro-etiqueta/services/api'

export default {
  name: 'CadastroEtiqueta',
  components: {
    FontAwesomeIcon,
  },
  props: {
    propostaId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      faChevronLeft,
      popoverShow: false,
      mode: 'none',
      etiquetas: [],
      valorAProcurar: null,
      immutableEtiquetas: [],
      cores: ['#376996', '#D62839', '#5FAD56', '#FF6B35', '#F5B700', '#EF709D', '#353F3C'],
      etiquetaAtual: {},
    }
  },
  computed: {
    currentHeader: {
      get() {
        if (this.mode === 'visualizacao') {
          return 'Etiquetas'
        }
        if (this.mode === 'adicao') {
          return 'Criar etiqueta'
        }
        if (this.mode === 'remover') {
          return 'Deletar etiqueta?'
        }
        return 'Alterar etiqueta'
      },
    },
  },
  watch: {
    valorAProcurar(value, oldValue) {
      if (value && value !== oldValue) {
        if (!this.immutableEtiquetas || this.immutableEtiquetas.length === 0) {
          this.immutableEtiquetas = [...this.etiquetas]
        }

        this.etiquetas = this.immutableEtiquetas.filter(fil => fil.descricao.toLowerCase().indexOf(value.toLowerCase()) >= 0)
      } else if (!value && oldValue) {
        this.etiquetas = [...this.immutableEtiquetas]
      }
    },
  },
  created() {
    this.mode = 'visualizacao'
    this.popoverShow = false
  },
  methods: {
    ...mapActions('listas', ['adicionarEtiqueta']),
    carregar() {
      api.getEtiquetasProposta(this.propostaId)
        .then(payload => {
          this.etiquetas = payload.data
        })
        .catch(err => {
          throw err
        })
    },
    onClose() {
      this.mode = 'none'
      this.popoverShow = false
    },
    onShow() {
      this.carregar()
      this.mudarModo('visualizacao')
      this.popoverShow = true
    },
    mudarModo(mode, tag) {
      if (mode === 'adicao') {
        this.etiquetaAtual = { cor: '#376996' }
      } else if (mode === 'edicao' || mode === 'remover') {
        this.etiquetaAtual = tag
      } else {
        this.etiquetaAtual = null
      }
      this.mode = mode
    },
    voltar() {
      this.mudarModo('visualizacao')
    },
    selecionado(etiqueta) {
      if (!etiqueta.selecionada) {
        this.etiquetaAtual = etiqueta
        this.etiquetaAtual.selecionada = true
        this.$emit('adicionar-etiqueta-selecionada', this.etiquetaAtual)
        api.cadastrarEtiquetaProposta(this.etiquetaAtual, this.propostaId)
          .then(() => {
            this.adicionarEtiqueta({ etiqueta: this.etiquetaAtual, propostaId: this.propostaId })
          })
      } else {
        this.etiquetaAtual = etiqueta
        this.etiquetaAtual.selecionada = false
        this.$emit('remover-etiqueta', this.etiquetaAtual)
        api.removerEtiquetaProposta(this.etiquetaAtual.id, this.propostaId)
      }
    },
    mudarCor(cor) {
      this.etiquetaAtual.cor = cor
    },
    update() {
      api.atualizarEtiqueta(this.etiquetaAtual)
        .then(() => {
          if (this.etiquetaAtual.selecionada) {
            this.$emit('update-etiqueta', this.etiquetaAtual)
            this.voltar()
          }
        })
        .catch(err => {
          this.$handleError(err)
          throw err
        })
    },
    save() {
      api.adicionarEtiquetaManual(this.etiquetaAtual)
        .then(payload => {
          this.etiquetaAtual.selecionada = true
          this.etiquetaAtual.id = payload.data.id
          this.etiquetas.push(payload.data)
          if (this.propostaId && this.propostaId > 0) {
            api.cadastrarEtiquetaProposta(this.etiquetaAtual, this.propostaId)
              .then(() => {
                this.adicionarEtiqueta({ etiqueta: this.etiquetaAtual, propostaId: this.propostaId })
                this.$emit('adicionar-etiqueta', this.etiquetaAtual)
                this.voltar()
              })
          }
        })
        .catch(err => {
          this.$handleError(err)
          throw err
        })
    },
    remove() {
      api.removerEtiqueta(this.etiquetaAtual.id)
        .then(() => {
          this.etiquetaAtual.selecionada = false
          this.$emit('remover-etiqueta', this.etiquetaAtual)
          const index = this.etiquetas.findIndex(find => find.id === this.etiquetaAtual.id)
          if (index >= 0) {
            this.etiquetas.splice(index, 1)
          }
          this.etiquetaAtual = null
          this.voltar()
        })
    },
  },
}
</script>
